import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Agenda from "../components/Agenda";
import Instructor from "../components/Instructor";
import Stats from "../components/Stats";
import Programme from "../components/Programme";
import Register from "../components/Register";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import ExitIntent from "../components/ExitIntent";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#060b17] text-slate-200 overflow-x-hidden">
      <Header />
      <Hero />
      <Agenda />
      <Instructor />
      <Stats />
      <Programme />
      <Register />
      <FAQ />
      <Footer />
      <ExitIntent />
    </div>
  );
};

export default LandingPage;
